import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1 } from '../apis.js';
const reqCases = collectionEngineV1('/case-vouchers');
export const getMultiple = (query, pagination) => reqCases('GET', `/?${toQuery({
    ...query,
    ...pagination,
})}`);
export const getByCaseId = (caseId, options) => reqCases('GET', `/${caseId}?${options?.getDeleted ? 'getDeleted=true' : ''}`);
export const getById = (id) => reqCases('GET', `/by-id/${id}`);
export const create = (caseId, newCaseVoucher, config) => reqCases('POST', `/${caseId}${config?.preventAdjustments ? '?preventAdjustments=true' : ''}`, {
    body: newCaseVoucher,
});
export const patchCaseVoucher = (caseVoucherId, patch, config) => reqCases('PATCH', `/${caseVoucherId}${config?.preventAdjustments ? '?preventAdjustments=true' : ''}`, {
    body: patch,
});
export const delCaseVoucher = (caseVoucherId, config) => reqCases('DELETE', `/${caseVoucherId}${config?.preventAdjustments ? '?preventAdjustments=true' : ''}`);
export const getDepositInsights = () => reqCases('GET', '/insights/deposits');
export const checkForDuplicates = async (creditorId, vouchers) => await reqCases('POST', '/duplicates/' + creditorId, {
    body: { vouchers },
});
//# sourceMappingURL=case-vouchers.js.map